import { useAppSelector } from '../../../../app/hooks';
import {
  selectCurrService,
  selectCurrServiceVersion,
} from '../../dataMeshSlice';
import { AIServiceEnum } from '../../dataRegistry';
import { getConfigForServiceAndVersion } from '../../utils/dataMeshUtils';
import { blueberryConfig } from '../configs/blueberryConfig';

/**
 * Get the config object for the current (blueberry) service and version
 * @returns {blueberryConfig | null} The config object - or null if the current service
 * is not blueberry or the version is not set
 */
export const useBlueberryConfig = (): blueberryConfig | null => {
  const currService = useAppSelector(selectCurrService);
  const currVersion = useAppSelector(selectCurrServiceVersion);

  if (currService != AIServiceEnum.blueberry || !currVersion) {
    return null;
  }

  return getConfigForServiceAndVersion(
    currService,
    currVersion
  ) as blueberryConfig;
};
